import TransmedFormSection from "../../../../dtos/transmed/process/form/section";
import TransmedRegistration from "../../../../dtos/transmed/process/registration/registration";
import TransmedProcessSlide from "./slide";

function TransmedProcessValid(props: {
  pointsDeadlineFirst: Date | null;
  points: number | null;
  sections: TransmedFormSection[];
  registration: TransmedRegistration;
}) {
  return (
    <TransmedProcessSlide>
      <h3>Înscrierea ta a fost validată!</h3>
      <span style={{ marginTop: "var(--gap-small)" }}>
        Clasamentul va fi afișat în:{" "}
        <b>{props.pointsDeadlineFirst?.toLocaleDateString("RO-ro")}</b>
      </span>
      <span className="label" style={{ marginTop: "var(--gap-small)" }}>
        Punctajul final va fi diferit de cel estimativ, întrucât acesta este
        calculat în funcție de cel mai mare punctaj obținut de un oarecare
        candidat, pentru fiecare secțiune.
      </span>
      {props.registration.points !== null ? (
        <div
          style={{
            marginTop: "var(--gap-xl)",
            display: "flex",
            flexDirection: "column",
            alignSelf: "flex-start",
            alignItems: "flex-start",
          }}
        >
          <h4>Punctaj obținut</h4>
          <h1 style={{ color: "var(--color-fasmr-blue)" }}>
            {props.registration.points.toFixed(2)}
          </h1>
          <div className="label">
            <b>Notă:</b> Punctajul pentru fiecare din cele 3 categorii este
            proporțional calculat între 0 și 100 în funcție de punctajul maxim
            obținut la categoria respectivă în centrul tău local.
          </div>
        </div>
      ) : (
        <div
          style={{
            marginTop: "var(--gap-xl)",
            display: "flex",
            flexDirection: "column",
            alignSelf: "stretch",
            alignItems: "center",
            gap: "var(--gap-medium)",
          }}
        >
          <h4>Punctaj Estimativ</h4>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "space-evenly",
              gap: "var(--gap-small)",
              alignSelf: "stretch",
            }}
          >
            {props.sections.map((section) => (
              <div
                key={section.id}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <b style={{ textAlign: "center" }}>{section.title}</b>
                <h1 style={{ color: "var(--color-fasmr-blue)" }}>
                  {section.subsections.reduce((acc, ss) => {
                    let sum = 0;

                    for (const f of ss.fields) {
                      const rf = props.registration.fields.find(
                        (val) => val.field === f.id
                      );
                      if (rf) {
                        sum += rf.quantity * f.points;
                      }
                    }

                    return acc + sum;
                  }, 0)}
                </h1>
              </div>
            ))}
          </div>
        </div>
      )}
    </TransmedProcessSlide>
  );
}

export default TransmedProcessValid;
